<template>
    <div class="intro" ref="intro">
        <div class="intro__container">
            <div class="intro__wrapper">
                <div class="intro__card">
                    <card ref="card" slug="the-bold" :class="cardClass"/>
                </div>
                <div class="intro__btn">
                    <button @click="onClick">Unveil your Destiny</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Card from '@/components/spread/Card';

    export default {
        components: {Card},

        data () {return {
            cardClass: ["--zoom", "--deg15"],
            cardDeg: 0,
            intervalID: null,
        }},

        mounted () {
            this.intervalID = setInterval(this.run, 20);
        },

        methods: {

            onClick () {
                clearInterval(this.intervalID);
                this.intervalID = null;
        
                let cardWrapperEl = this.$refs.card.$el.getElementsByClassName("card__wrapper")[0];
                cardWrapperEl.style.transform = "rotateY("+ (Math.floor(this.cardDeg/360)+1)*360 +"deg)";
                cardWrapperEl.style.transitionDuration = "0.8s";
                this.cardClass = ['--zoom', '--flipped'];

                setTimeout(() => {

                    this.$emit("done", {
                        x: this.$refs.card.$el.offsetLeft,
                        y: this.$refs.card.$el.offsetTop - 28 // button margin bottom and top because why not,
                    });
                    
                }, 800);
            },

            run () {
                let cardWrapperEl = this.$refs.card.$el.getElementsByClassName("card__wrapper")[0];
                this.cardDeg++;

                cardWrapperEl.style.transform = "rotateY("+this.cardDeg+"deg)";
                cardWrapperEl.style.transitionDuration = "0";     
            },

        }

    }
</script>
